const builderQuerySetup = ({
  builder, apiConfig, service, queryType = 'query',
}) => {
  return builder[queryType]({
    query: ({
      offerType, params = {}, ...rest
    } = {}) => ({
      service,
      method: 'post',
      responseType: 'text',
      isSupportLoader: true,
      collectHeaderToken: true,
      ...apiConfig,
      ...rest,
      body: params,
      urlParams: { offerType },
    }),
  });
};

const endpointsBuilder = servicesConfig => (builder) => {
  return servicesConfig.map(({ service, queryType, ...configRest }) => ({
    [service]: builderQuerySetup({
      builder, apiConfig: configRest, service, queryType,
    }),
  })).reduce((acc, fn) => Object.assign(acc, fn), {});
};

export default endpointsBuilder;
